var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { guid } from '../utils/helper';
import Time from '../utils/time';
import { reportJSInfo } from '@max/meituan-uni-report';
import { request as uniRequest } from '@max/meituan-uni-network';
import { getPlatformType } from '@nibfe/mkt-env-api';
import XhrClient from '../utils/xhr';
import { getRiskParams } from '@nibfe/mkt-risk-api';
import { Base64 } from 'js-base64';
import { TechStackUtil } from '@nibfe/mkt-common-utils';
import request from 'superagent';
import addRequestSignature from '../utils/addRequestSignature';
const platformType = getPlatformType();
const IS_DP = (platformType === null || platformType === void 0 ? void 0 : platformType.includes('dpApp')) || (platformType === null || platformType === void 0 ? void 0 : platformType.includes('dpMina'));
const isMRN = TechStackUtil.isMRN();
const base = () => {
    if (IS_DP) {
        return 'https://cube.dianping.com';
    }
    else {
        return 'https://cube.meituan.com';
    }
};
// 接口文档：https://km.sankuai.com/collabpage/1793070675
const INIT_API = function () {
    let domain = base();
    let url = '/topcube/api/toc/playWay/preSendCoupon';
    return domain + url;
}();
const REDPACKET_API = function () {
    let domain = base();
    let url = '/topcube/api/toc/playWay/sendCoupon';
    return domain + url;
}();
const getSourceType = () => {
    return IS_DP ? 'DIAN_PING' : 'MEI_TUAN';
};
export const preSendCoupon = (params, callback) => __awaiter(void 0, void 0, void 0, function* () {
    // 画布内偶发window?.Block?.TIME不存在
    yield Time.on((serverTime) => {
        const time = serverTime.server;
        const nonceRandom = guid();
        let data = {
            playWaySecrets: params.campaignKeys,
            sourceType: getSourceType(),
            userId: params.userId,
            requestTime: time,
            nonceRandom,
            extraInfoMap: params.extraInfoMap,
            appType: params.appType,
            requestSign: Base64.encode(`playWaySign,${Base64.encode(time + ',' + nonceRandom)}`),
            cubeActivityUrl: isMRN ? '' : window.location.href,
            cubeActivityId: params.pageId || '328189'
            // cubeActivityUrl: 'https://cube.meituan.com/cube/block/b7958fc73e91/328189/index.html'
        };
        const url = `${INIT_API}?k=${params.pageId}`;
        // addRequestSignature('POST', REDPACKET_API, data, {'Content-Type': 'application/x-www-form-urlencoded'})
        uniRequest({
            url: url,
            data: data,
            method: 'POST',
            header: {
                "content-type": "application/json"
            },
            _meituan: {
                requestType: 'MRNUtils',
                mrnChannel: 'hotel'
            },
            success(res) {
                var _a;
                callback && callback(res);
                if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) !== 0) {
                    const error = new Error('预领券玩法接口返回异常');
                    reportJSInfo({
                        secCategory: 'ajax',
                        level: 'warn',
                        content: '预领券玩法接口返回异常',
                        error,
                        tags: {
                            res,
                            params,
                            url
                        }
                    });
                }
            },
            fail(error) {
                error.message = '预领券玩法接口异常';
                reportJSInfo({
                    secCategory: 'ajax',
                    level: 'warn',
                    content: '预领券玩法接口异常',
                    error,
                    tags: {
                        params,
                        url
                    }
                });
                callback && callback({});
            }
        });
    });
});
export const sendCoupon = (params, callback) => __awaiter(void 0, void 0, void 0, function* () {
    const { token, userId, uuid, campaignKeys, cityId, realCityId, pageId } = params || {};
    yield Time.on((serverTime) => __awaiter(void 0, void 0, void 0, function* () {
        let Token = token || '';
        if (!userId) {
            callback && callback({
                body: {
                    code: -1001
                }
            });
            return;
        }
        //风控参数
        const riskParams = yield getRiskParams(2);
        const time = serverTime.server;
        const nonceRandom = guid();
        let _data = {
            positionCityId: realCityId || 1,
            uuid: uuid,
            visitCityId: cityId || 1,
            playWaySecrets: campaignKeys,
            userId: userId,
            sourceType: getSourceType(),
            weixinCode: '',
            voucherSourceType: (platformType === null || platformType === void 0 ? void 0 : platformType.includes('App')) ? 'INNER_APP' : 'OUTER_APP',
            requestTime: time,
            nonceRandom,
            requestSign: Base64.encode(`playWaySign,${Base64.encode(time + ',' + nonceRandom)}`),
            mini_program_token: Token,
            cubeActivityUrl: isMRN ? '' : window.location.href,
            cubeActivityId: pageId,
            ecube_sid: Token,
            extend: params.extend,
            apptype: params.appType
        };
        _data.RiskForm = Base64.encode(JSON.stringify(riskParams));
        console.log(_data, 'sendC');
        let mtgsig = yield addRequestSignature('POST', REDPACKET_API, _data, {
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        // console.log(mtgsig, 'mtgsig')
        // return
        let req = request.post(REDPACKET_API).withCredentials().set('Content-Type', 'application/x-www-form-urlencoded');
        // .set('Mtgsig', mtgsig)
        if (mtgsig) {
            req.set('mtgsig', mtgsig);
        }
        req.send(_data).end(function (err, res) {
            if (err) {
                // 使用原生xhr 再发送一次
                XhrClient(REDPACKET_API, null, _data, (xhrErr, body) => {
                    if (xhrErr) {
                        reportJSInfo({
                            secCategory: 'ajax',
                            level: 'warn',
                            content: '多状态红包发券错误',
                            error: err,
                            tags: {
                                res: body,
                                params,
                                url: REDPACKET_API
                            }
                        });
                        callback && callback(body);
                    }
                    else {
                        callback && callback(body);
                    }
                });
            }
            else {
                if (res && res.body && (res.body.code === 2032 || res.body.code === 99999)) {
                    reportJSInfo({
                        secCategory: 'ajax',
                        level: 'warn',
                        content: '多状态红包KNB发券验签失败',
                        error: err,
                        tags: {
                            res,
                            params,
                            url: REDPACKET_API
                        }
                    });
                }
                callback && callback(res);
            }
        });
    }));
});
